<template>
  <div class="irp-opportunities-tab" data-testid="irp-opportunities-tab"
    >Opportunities</div
  >
</template>
